import { DeliveryService } from '../../components/Pages/Orders/Adapter/enums';

/** @description Checks if service value is 'dhl' or 'dhl-2' */
export function isDhlService(value?: string): boolean {
  if (!value) return false;

  return value === DeliveryService.DHL || value === DeliveryService.DHL_2;
}

/** @description
 * Prepares query-params and replaces 'dhl-2' with 'dhl'.
 *
 * Usage example in fetch-hook:
 * config: {
 *   paramsSerializer: serializeParamsWithDhlService(),
 * },
 * */
export function prepareParamsWithDhlService() {
  return (params: Record<string, any>): string => {
    // Clone to avoid mutating original
    const normalized = { ...params };

    if (normalized.deliveryService === DeliveryService.DHL_2) {
      normalized.deliveryService = DeliveryService.DHL;
    }

    return new URLSearchParams(normalized).toString();
  };
}

/** @description
 * Transforms body to change 'dhl-2' to 'dhl' in payload.
 *
 * UsageExample in fetch-hook:
 * config: {
 *   transformRequest: [transformBodyWithDhlService()],
 * }
 * */
export function transformBodyWithDhlService() {
  return (data: any, headers?: any): any => {
    if (data?.deliveryService === DeliveryService.DHL_2) {
      return {
        ...data,
        deliveryService: DeliveryService.DHL,
      };
    }

    return data;
  };
}

export default {
  isDhlService,
};
